export const ROLES = {
  STAFF: 'STAFF',
  MANAGER: 'MANAGER',
  LEADER: 'LEADER',
}

export const DEFAULT_COURSE_COVER =
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRMvYMRIRJwMvajAMB8xPspFyb5YNzr1Xz4ZQ&usqp=CAU'

export const ACADEMY_ROLES = { ACADEMY_MANAGER: 'ACADEMY_MANAGER', ACADEMY_TRAINEE: 'ACADEMY_TRAINEE' }

export const STAFF_DESIGNATION = [
  {
    value: 'Beginning Infant Educator',
    label: 'Beginning Infant Educator',
  },
  {
    value: 'Infant Educator',
    label: 'Infant Educator',
  },
  {
    value: 'Senior Infant Educator',
    label: 'Senior Infant Educator',
  },
  {
    value: 'Beginning Early Years Educator',
    label: 'Beginning Early Years Educator',
  },
  {
    value: 'Early Years Educator',
    label: 'Early Years Educator',
  },
  {
    value: 'Senior Early Years Educator',
    label: 'Senior Early Years Educator',
  },
  {
    value: 'Lead Early Years Educator',
    label: 'Lead Early Years Educator',
  },
  {
    value: 'Beginning Preschool Educator',
    label: 'Beginning Preschool Educator',
  },
  {
    value: 'Preschool Educator',
    label: 'Preschool Educator',
  },
  {
    value: 'Senior Preschool Educator',
    label: 'Senior Preschool Educator',
  },
  {
    value: 'Lead Preschool Educator',
    label: 'Lead Preschool Educator',
  },
  {
    value: 'Curriculum/Pedagogy Specialist',
    label: 'Curriculum/Pedagogy Specialist',
  },
  {
    value: 'Deputy Centre Leader',
    label: 'Deputy Centre Leader',
  },
  {
    value: 'Centre Leader',
    label: 'Centre Leader',
  },
  {
    value: 'Senior Centre Leader',
    label: 'Senior Centre Leader',
  },
  {
    value: 'Learning Support Educator',
    label: 'Learning Support Educator',
  },
  {
    value: 'Senior Learning Support Educator',
    label: 'Senior Learning Support Educator',
  },
  {
    value: 'Lead Learning Support Educator',
    label: 'Lead Learning Support Educator',
  },
  {
    value: 'Senior Lead Learning Support Educator',
    label: 'Senior Lead Learning Support Educator',
  },
  {
    value: 'Cluster Manager',
    label: 'Cluster Manager',
  },
  {
    value: 'Beginning Early Intervention Educator',
    label: 'Beginning Early Intervention Educator',
  },
  {
    value: 'Early Intervention Educator',
    label: 'Early Intervention Educator',
  },
  {
    value: 'Senior Early Intervention Educator',
    label: 'Senior Early Intervention Educator',
  },
  {
    value: 'Lead Early Intervention Educator',
    label: 'Lead Early Intervention Educator',
  },
  {
    value: 'Senior Lead Early Intervention Educator',
    label: 'Senior Lead Early Intervention Educator',
  },
  {
    value: 'Centre Manager',
    label: 'Centre Manager',
  },
  {
    value: 'Director',
    label: 'Director',
  },
]

export const COURSE_LIMIT = 9

export const PermissionsTableTemplate = [
  {
    label: 'administrator',
    modules: [
      {
        label: 'administration',
        goTo: '/settings/administration',
        icon: 'administration',
        iconType: 'littlelives',
        staffEnrolled: 0,
        allowActiveAll: false,
        isActiveAll: false,
        iconClass: 'module-icon mdi-36px',
        module: 'ADMINISTRATION',
        isAllowAutoAssign: false,
      },
    ],
  },
  {
    label: 'staff-management',
    modules: [
      {
        label: 'academy-training',
        goTo: '/settings/academy-training',
        icon: 'academy',
        iconType: 'littlelives',
        staffEnrolled: 0,
        allowActiveAll: false,
        isActiveAll: false,
        iconClass: 'module-icon mdi-36px',
        module: 'ACADEMY',
        isAllowAutoAssign: true,
      },
      {
        label: 'performance',
        goTo: '/settings/performance',
        icon: 'performance',
        iconType: 'littlelives',
        staffEnrolled: 0,
        allowActiveAll: false,
        isActiveAll: false,
        iconClass: 'module-icon mdi-36px',
        module: 'PERFORMANCE',
        isAllowAutoAssign: true,
      },
    ],
  },
]

export const QUESTION_TYPE = {
  CHECK_BOX: 'CHECK_BOX',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  PARAGRAPH: 'PARAGRAPH',
}

export const UPDATE_COURSE_STATUS = {
  DUPLICATE: 'DUPLICATE',
  ACTIVATED: 'ACTIVATED',
  ARCHIVED: 'ARCHIVED',
  DEACTIVATED: 'DEACTIVATED',
  DRAFT: 'DRAFT',
}

export const MODULES = {
  ADMINISTRATION: 'ADMINISTRATION',
  ACADEMY: 'ACADEMY',
  PERFORMANCE: 'PERFORMANCE',
}

export const USER_STATUS = {
  ACTIVATED: 'ACTIVATED',
  DEACTIVATED: 'DEACTIVATED',
  PENDING: 'PENDING',
}

export const COURSE_ENROLL_STATUS = {
  APPROVED: 'APPROVED',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  ENROLLED: 'ENROLLED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
}

export const COURSE_TYPE = {
  EXTERNAL: 'EXTERNAL',
  INTERNAL: 'INTERNAL',
  LITTLE_ACADEMY: 'LITTLE_ACADEMY',
}

export const COURSE_LEARN_MODE = {
  BLENDED: 'BLENDED',
  ONLINE_SCHEDULED: 'ONLINE_SCHEDULED',
  ONLINE_SELF_PACED: 'ONLINE_SELF_PACED',
  ON_LOCATION: 'ON_LOCATION',
}

export const COURSE_ENROLL_ALLOWED_SORT_FIELD = {
  ENROLLED_DATE: 'ENROLLED_DATE',
  TITLE: 'TITLE',
}

export const SORT_DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const SORT_FIELD = {
  DATE: 'DATE',
  STATUS: 'STATUS',
  TITLE: 'TITLE',
  SCORE: 'SCORE',
}

export const PLAYLIST_STATUS = {
  DRAFT: 'DRAFT',
  ACTIVATED: 'ACTIVATED',
  DEACTIVATED: 'DEACTIVATED',
  ARCHIVED: 'ARCHIVED',
}

export const ACTIONS_PLAYLISTS = {
  ACTIVATE: 'ACTIVATE',
  DUPLICATE: 'DUPLICATE',
  DEACTIVATE: 'DEACTIVATE',
}

export const MY_COURSE_ENROLL_STATUS = {
  COMPLETED: 'COMPLETED',
  COURSE_ENDED: 'COURSE_ENDED',
  IN_PROGRESS: 'IN_PROGRESS',
  UNCOMPLETED: 'UNCOMPLETED',
  UPCOMING: 'UPCOMING',
}

export const PLAYLIST_USER_PROGRESS_STATUS = {
  ASSIGNED: 'ASSIGNED',
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
}

export const MY_PLAYLIST_ALLOWED_SORT_FIELD = {
  ASSIGNED_DATE: 'ASSIGNED_DATE',
  DATE: 'DATE',
  TITLE: 'TITLE',
}

export const TOPIC_ENROLL_STATUS = {
  COMPLETED: 'COMPLETED',
  PENDING: 'PENDING',
  SUBMITTED: 'SUBMITTED',
}

export const VERIFY_STATUS = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
}

export const COURSE_STATUS = {
  ACTIVATED: 'ACTIVATED',
  ARCHIVED: 'ARCHIVED',
  DEACTIVATED: 'DEACTIVATED',
  DRAFT: 'DRAFT',
}

export const USER_ACTIVITY_TARGET_TYPE = {
  APPRAISAL_ASSIGN: 'APPRAISAL_ASSIGN',
  CLASS: 'CLASS',
  COMMENT: 'COMMENT',
  COURSE: 'COURSE',
  LESSON: 'LESSON',
  PLAYLIST: 'PLAYLIST',
  REVIEW_PROCESS: 'REVIEW_PROCESS',
  SCHOOL: 'SCHOOL',
  TOPIC: 'TOPIC',
  USER: 'USER',
}

export const USER_ACTIVITY_ACTION = {
  APPRAISAL_FINALIZED: 'APPRAISAL_FINALIZED',
  APPRAISAL_SIGN_OFF: 'APPRAISAL_SIGN_OFF',
  APPRAISAL_SUBMITTED: 'APPRAISAL_SUBMITTED',
  APPRAISAL_SUBMIT_FINALIZED: 'APPRAISAL_SUBMIT_FINALIZED',
  ACTIVATE_PLAYLIST: 'ACTIVATE_PLAYLIST',
  CREATE_PLAYLIST: 'CREATE_PLAYLIST',
  DEACTIVATE_PLAYLIST: 'DEACTIVATE_PLAYLIST',
  DUPLICATE_PLAYLIST: 'DUPLICATE_PLAYLIST',
  REMOVE_PLAYLIST: 'REMOVE_PLAYLIST',
  UPDATE_PLAYLIST: 'UPDATE_PLAYLIST',
}

export const UPLOADER_STATE = {
  DEFAULT: 'DEFAULT',
  UPLOADING: 'UPLOADING',
  UPLOADED: 'UPLOADED',
  ERROR: 'ERROR',
  INTERRUPT: 'INTERRUPT',
  OVERSIZE: 'OVERSIZE',
  EXTRACTING: 'EXTRACTING',
  EXTRACT_SUCCESS: 'EXTRACT_SUCCESS',
  EXTRACT_FAIL: 'EXTRACT_FAIL',
}

export const MEDIA_STATUS = {
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
  READY: 'READY',
}

export const TOPIC_TYPE = {
  AUDIO: 'AUDIO',
  QUIZ: 'QUIZ',
  VIDEO: 'VIDEO',
  SCORM: 'SCORM',
}

export const DEFAULT_FILE_SIZE_LIMIT = 200000

export const DEFAULT_DESC_LENGTH_LIMIT = 100

export const DEFAULT_TIME_STRING_FORMAT = 'HH mm ss'

export const DEFAULT_DATE_STRING_FORMAT = 'YYYY-MM-DD'

export const CMI_LESSON_STATUS = {
  PASSED: 'passed',
}

export const SHARING_OPTION = {
  ASSIGNABLE: 'ASSIGNABLE',
  EDITABLE: 'EDITABLE',
}

export const APPRAISAL_STATUS = {
  NEW: 'NEW',
  ASSESSMENT_IN_PROGRESS: 'ASSESSMENT_IN_PROGRESS',
  PENDING_REVIEW: 'PENDING_REVIEW',
  PENDING_MODERATION: 'PENDING_MODERATION',
  ONE_ON_ONE_READY: 'ONE_ON_ONE_READY',
  ONE_ON_ONE_IN_PROGRESS: 'ONE_ON_ONE_IN_PROGRESS',
  FINALISED: 'FINALISED',
  COMPLETED: 'COMPLETED',
}

export const APPRAISAL_INPUT_TYPE = {
  TEXT: 'TEXT',
  SCORES: 'SCORES',
  DROPDOWN: 'DROPDOWN',
  COMMENT: 'COMMENT',
}

export const APPRAISAL_ACTION_TYPE = {
  SIGN_OFF_AND_UPDATE_STATUS: 'SIGN_OFF_AND_UPDATE_STATUS',
  OPEN_APPRAISAL: 'OPEN_APPRAISAL',
  SAVE_AND_UPDATE_STATUS: 'SAVE_AND_UPDATE_STATUS',
}

export const APPRAISAL_INPUT_PERMISSION = {
  COMMENT: 'COMMENT',
  EDIT: 'EDIT',
  EVIDENCE_COMMENT: 'EVIDENCE_COMMENT',
  CONVERSATION: 'CONVERSATION',
  VIEW_CHECKLIST_EXPECTATION: 'VIEW_CHECKLIST_EXPECTATION',
  EDIT_CHECKLIST_EXPECTATION: 'EDIT_CHECKLIST_EXPECTATION',
}

export const APPRAISAL_KEY = {
  APPRAISEE: 'appraisee',
}

export const ROLE_TYPE = {
  APPRAISER: 'APPRAISER',
  APPRAISEE: 'APPRAISEE',
}

export const APPRAISAL_CTA_BUTTON_TYPE = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
}

export const APPRAISAL_COMMENT_TYPE = {
  COMMENT: 'COMMENT',
  MODERATION_COMMENT: 'MODERATION_COMMENT',
  SIGN_OFF_COMMENT: 'SIGN_OFF_COMMENT',
  UPDATE_STATUS_COMMENT: 'UPDATE_STATUS_COMMENT',
  EVIDENCE_COMMENT: 'EVIDENCE_COMMENT',
}

export const ACTION_PARAMS_CONDITION = {
  WHEN_ALL_SIGNED_OFF: 'when_all_signed_off',
}

export const DEFAULT_LIMIT = 10

export const IMPORT_CHECKLIST_ERRORS = {
  START_DATE_FORMAT: 'Start date is not in correct format',
  END_DATE_FORMAT: 'End date is not in correct format',
  START_DATE_AFTER_END_DATE: 'Start date cannot after end date',
  END_DATE_BEFORE_START_DATE: 'End date cannot before start date',
  CANNOT_FOUND_USER_EMAIL: 'Cannot found user email',
  CANNOT_FOUND_CENTRE: 'Cannot found the centre',
}
